var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHardware1Line46(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "hardware_1-line-46") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 5.95c0-0.25-0.25-0.45-0.5-0.45-4.35 0-8.6-1.7-11.65-4.85-0.2-0.2-0.55-0.2-0.7 0-3.050 3.15-7.3 4.9-11.65 4.85-0.25 0-0.5 0.2-0.5 0.45 0 0.2-0.9 18.4 12.25 25.45 0.1 0.1 0.15 0.1 0.25 0.1s0.15 0 0.25-0.050c13.15-7.1 12.25-25.3 12.25-25.5zM16 30.45c-11.2-6.25-11.55-21.1-11.5-23.95 4.3-0.1 8.45-1.8 11.5-4.8 3.1 3 7.25 4.7 11.5 4.8 0.050 2.85-0.25 17.7-11.5 23.95zM22.15 11.65l-6.65 6.65-3.15-3.15c-0.2-0.2-0.5-0.2-0.7 0s-0.2 0.5 0 0.7l3.5 3.5c0.1 0.1 0.25 0.15 0.35 0.15s0.25-0.050 0.35-0.15l7-7c0.2-0.2 0.2-0.5 0-0.7s-0.5-0.2-0.7 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHardware1Line46);
export default __webpack_public_path__ + "static/media/hardware_1-line-46.1ef55f6e29d15b53be82f7cd20d334d8.svg";
export { ForwardRef as ReactComponent };